import { useAudioVideo, useMeetingManager } from "amazon-chime-sdk-component-library-react";
import { useReactionBroadcast } from "@platform/features/video/hooks/useReactionBroadcast";
import VideoMeetingControlsReactions from "./VideoMeetingControlsReactions";
import type { ContainerBreakpoints } from "../../videoMeeting.types";

export type Props = {
  containerBreakpoints: ContainerBreakpoints;
};

export function VideoMeetingControlsReactionsContainer({
  containerBreakpoints,
}: Props) {
  const audioVideo = useAudioVideo();
  const meetingManager = useMeetingManager();
  const localAttendeeId =
    meetingManager.meetingSession?.configuration.credentials?.attendeeId ?? null;

  const { sendReaction, isThrottled } = useReactionBroadcast(
    audioVideo,
    localAttendeeId
  );

  return (
    <VideoMeetingControlsReactions
      containerBreakpoints={containerBreakpoints}
      isThrottled={isThrottled}
      onSendReaction={sendReaction}
    />
  );
}

export default VideoMeetingControlsReactionsContainer;
